<template lang="html">
  <div class="agent-detail-commission--inner">
    <div class="window-details-toolbar">
      <div class="window-details-toolbar__items">
        <button class="btn--default"
        >
          <span>Losing</span>
        </button>
        <button class="btn--default"
        >
          <span>Rolling</span>
        </button>

        <div class="commission-info-wrap">
          <div class="commission-info">
            <div class="commission-info__label">total losing :</div>
            <div class="commission-info__amount">100,000.00</div>
          </div>

          <div class="commission-info">
            <div class="commission-info__label">total rolling :</div>
            <div class="commission-info__amount">100,000.00</div>
          </div>
        </div>
      </div>
    </div>

    <tbl
    >
      <tbl-inner>
        <tbl-head>
          <tbl-row>
            <tbl-td
              :sort="true"
              @click.native="sort('created_at')"
              name="date">
              date
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('login_id')"
              name="login-id">
              login id
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('login_name')"
              name="login-name">
              login name

            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('bet_amount')"
              name="betting-amount">
              betting amount
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('win_amount')"
              name="win-amount">
              win amount
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('net_amount')"
              name="net-amount">
              net amount
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('rate')"
              name="rate">
              rate
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('commission')"
              name="commission">
              commission
            </tbl-td>

          </tbl-row>
        </tbl-head>
        <tbl-body>
          <tbl-row
          >
            <tbl-td name="date">
              date
            </tbl-td>

            <tbl-td name="login-id">
              login id
            </tbl-td>

            <tbl-td name="login-name">
              login name

            </tbl-td>

            <tbl-td name="betting-amount">
              betting amount
            </tbl-td>

            <tbl-td name="winj-amount">
              win amount
            </tbl-td>

            <tbl-td name="net-amount">
              net amount
            </tbl-td>

            <tbl-td name="rate">
              rate
            </tbl-td>

            <tbl-td name="commission">
              commission
            </tbl-td>

          </tbl-row>
        </tbl-body>
      </tbl-inner>

      <tbl-footer>
        <pagination
          :total="agentCodesCnt"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>

    </tbl>

  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import Pagination from '@/components/base/Pagination'

export default {
  name: 'agent-detail-commission',

  components: {
  	Search,
  	CheckDataList,
    Pagination
  }
}
</script>
